import { Box, Button, Paper, TextField, useTheme } from "@mui/material";
import { InsuranceFormData } from "./fieldData";
import { UseFormReturn } from "react-hook-form";
import { useMutation } from "react-query";
import { Fragment, useContext, useEffect, useState } from "react";
import { EncounterContextv1 } from "..";
import moment from "moment";
import {
  getAllinsuranceType,
  getCptGroups,
  getinsPlans,
  getinsuranceByType,
} from "../services";
import usePopup from "@hooks/usePopup";
import api from "@services/apiList";
import { FormOnChangeEventType } from "../../../../EMR/types";
import { CustomFormField } from "@utilifiles/component/CustomFormElement";
import useAuthentication from "@hooks/useAuthentication";

function Insuranceform({
  formcontrol,
  SetCopay,
}: {
  formcontrol: UseFormReturn;
  SetCopay: any;
}) {
  const theme = useTheme();
  const context = useContext(EncounterContextv1);
  const {user} = useAuthentication()
  const { CustomModal } = usePopup();
  const copay = context?.encounterDetails?.copay || [];
  const { control, watch, resetField, setValue, register, getValues } =
    formcontrol;
  const { patientEncounterApi } = api;
  const [open, setOpen] = useState(false);
  const [isNameChange, setIsNameChange] = useState(false);
  const style = {
    // position: "absolute" as "absolute",
    // top: "50%",
    // left: "50%",
    // transform: "translate(-50%, -50%)",
    // bgcolor: "background.paper",
    // boxShadow: 24,
    width: "100%",
  };

  const { mutate: getInsuranceType, data: InsuranceTypeList } =
    useMutation(getAllinsuranceType);
  const { mutate: getTPAorInsurance, data: TPAorInsuranceList } =
    useMutation(getinsuranceByType);
  const { mutate: getInsuranceName, data: InsuranceNameList } = useMutation(
    getinsuranceByType,
    {
      onSuccess: (nameList) => {
        if (context?.encounterDetails) {
          const { insurancePatient } = context?.encounterDetails;
          if (
            context?.encounterDetails?.insurancePatient?.id &&
            !isNameChange
          ) {
            const insuranceName = nameList?.response?.find((item: any) => {
              // console.log(item.name);
              return item.id == insurancePatient?.insuranceGroup;
            });
            if (insuranceName?.name && insuranceName?.id) {
              setValue("InsuranceName", {
                name: insuranceName?.name,
                id: insuranceName?.id,
              });
            }
          }
        }
      },
    }
  );
  const { mutate: getInsurancePlan, data: inusurancePlanList } =
    useMutation(getinsPlans);

  const { mutate: getAllCptGroups, data: cptGroups } =
    useMutation(getCptGroups);

  useEffect(() => {
    getInsuranceType();
    getAllCptGroups();
  }, []);
  const clearOtherField = (fieldsName: string[]) => {
    fieldsName.forEach((field) => {
      resetField(field);
    });
  };
  const OnTypeChange = (data: any) => {
    const insType = data?.target?.value?.id;
    getTPAorInsurance(insType);
    clearOtherField([
      "TPA",
      "Insurance",
      "InsuranceName",
      "InsurancePlan",
      "cardNumber",
      "PolicyNumber",
      "PolicyFrom",
      "PolicyTill",
    ]);
  };

  const onInsuranceNameChanges = () => {
    const formData = getValues();
    getInsurancePlan({
      clinicId:user?.clinicId,
      insType: formData?.insuranceType?.id,
      insName: formData?.TPA.id,
    });
    clearOtherField([
      "InsurancePlan",
      "cardNumber",
      "PolicyNumber",
      "PolicyFrom",
      "PolicyTill",
    ]);
  };
  const OninsuranceChanges = () => {
    const formData = getValues();
    getInsurancePlan({
      clinicId:user?.clinicId,
      insType: formData?.insuranceType?.id,
      insName: formData?.Insurance.id,
    });
    clearOtherField([
      "InsurancePlan",
      "cardNumber",
      "PolicyNumber",
      "PolicyFrom",
      "PolicyTill",
    ]);
  };

  const OnTPAChanges = () => {
    // console.log("inside OnTPAChanges");

    const insType = 2;
    // console.log(watch("TPA"));
    setIsNameChange(true);
    getInsuranceName(insType);
    // console.log("....", InsuranceNameList);

    clearOtherField([
      "InsuranceName",
      "InsurancePlan",
      "cardNumber",
      "PolicyNumber",
      "PolicyFrom",
      "PolicyTill",
    ]);
  };

  const collectCopayDeductible = () => {
    const copayDetails: any[] = [];
    cptGroups?.response?.forEach((item: any) => {
      let copay = parseFloat(
        (document.getElementById("copay" + item.id) as HTMLInputElement)
          ?.value || "0"
      );
      let deductible = parseFloat(
        (document.getElementById("deductible" + item.id) as HTMLInputElement)
          ?.value || "0"
      );
      copay < 0 && (copay = 0);
      deductible < 0 && (deductible = 0);
      const obj = {
        id: item.id,
        name: item.name,
        copay,
        deductible,
      };
      copayDetails.push(obj);
      SetCopay(copayDetails);
    });
    // console.clear();
    // console.log("copayDetails-------->", copayDetails);
    setValue("copayDetails", JSON.stringify(copayDetails));
    setOpen(false);
  };

  const policyFomChange = (e: FormOnChangeEventType) => {
    const { value } = e.target;
    const currentDate = moment(value);
    const oneYearLater = currentDate.add(1, "years");
    const formattedDate = oneYearLater.format("YYYY-MM-DD");
    setValue("PolicyTill", formattedDate);
  };

  useEffect(() => {
    if (context?.encounterDetails?.insurancePatient?.id) {
      const { insurancePatient } = context?.encounterDetails;
      if (insurancePatient != "") {
        setValue("insuranceType", {
          name: insurancePatient.insurancetype_name,
          id: insurancePatient.insuranceType,
        });
        getTPAorInsurance(insurancePatient.insuranceType);
      }
      setValue("TPA", {
        name: insurancePatient.insurance_name,
        id: insurancePatient.insurance,
      });

      if (insurancePatient.insuranceType == 1) {
        OnTPAChanges();
      }

      setValue("Insurance", {
        name: insurancePatient.insurance_name,
        id: insurancePatient.insurance,
      });

      getInsurancePlan({
        method: "post",
        endPoint: patientEncounterApi.getInsurancePlan,
        data: {
          insType: watch("insuranceType")?.id,
          insName: watch("insurance")?.id || watch("TPA")?.id,
        },
      });

      setValue("InsurancePlan", {
        name: insurancePatient.inPlan_name,
        id: insurancePatient.insurancePlan,
      });
      setValue("cardNumber", insurancePatient.cardNo);
      setValue("PolicyNumber", insurancePatient.policyNo || "");
      setValue("PolicyTill", insurancePatient.policyValidity);
      const validForm = new Date(insurancePatient.policyValidityFrom);
      setValue(
        "PolicyFrom",
        isNaN(validForm.getTime()) ? null : insurancePatient.policyValidityFrom
      );
      setValue("AsopNo", insurancePatient.asopNo);
      getInsurancePlan({
        clinicId:user?.clinicId,
        insType: insurancePatient.insuranceType,
        insName: insurancePatient.insurance,
      });
    } else {
      // console.log("inside");

      resetField("insuranceType");
      resetField("InsurancePlan");
      resetField("InsuranceName");
      resetField("TPA");
      resetField("cardNumber");
      setValue("PolicyFrom", null);
      // console.log(watch("PolicyFrom"));
      setValue("PolicyTill", null);
    }
  }, [context?.encounterDetails]);

  useEffect(() => {
    if (context?.encounterDetails?.copay?.length == 0) {
      cptGroups?.response?.length &&
        cptGroups?.response?.length > 0 &&
        collectCopayDeductible();
      // console.log("inside insurance group cptGroups ---->",cptGroups)
    } else {
      context?.encounterDetails?.copay
        ? SetCopay(context?.encounterDetails?.copay)
        : collectCopayDeductible();
    }
  }, [cptGroups, context?.encounterDetails]);

  // const opencopay=()=>{
  //   setOpen(true)
  // }

  return (
    <div className="relative pt-3">
      <Paper className="pt-2">
        <span
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
          }}
          className="absolute px-2 rounded top-0 left-3"
        >
          Insurance{" "}
          {Array(20)
            .fill(null)
            .map((_, i) => (
              <Fragment key={i}>&nbsp;</Fragment>
            ))}
        </span>
        <div className="flex justify-end px-4">
          <Button onClick={() => setOpen(true)} variant="outlined">
            copay / deductible
          </Button>
        </div>
        <div className="grid grid-cols-4 gap-4 p-4">
          <CustomFormField
            control={control}
            {...InsuranceFormData.insuranceType}
            options={InsuranceTypeList?.response || []}
            rules={{
              ...InsuranceFormData.insuranceType.rules,
              onChange: OnTypeChange,
            }}
          />

          {watch("insuranceType")?.id == 2 ? (
            <CustomFormField
              control={control}
              options={TPAorInsuranceList?.response}
              {...InsuranceFormData.Insurance}
              rules={{
                ...InsuranceFormData.insuranceType.rules,
                onChange: OninsuranceChanges,
              }}
            />
          ) : (
            <CustomFormField
              control={control}
              {...InsuranceFormData.TPA}
              options={TPAorInsuranceList?.response}
              rules={{
                ...InsuranceFormData.insuranceType.rules,
                onChange: OnTPAChanges,
              }}
            />
          )}

          {watch("insuranceType")?.id == 1 && (
            <CustomFormField
              control={control}
              options={InsuranceNameList?.response}
              {...InsuranceFormData.InsuranceName}
              rules={{
                ...InsuranceFormData.InsuranceName.rules,
                onChange: onInsuranceNameChanges,
              }}
            />
          )}

          <CustomFormField
            control={control}
            {...InsuranceFormData.InsurancePlan}
            options={inusurancePlanList?.response}
          />
          <CustomFormField
            control={control}
            {...InsuranceFormData.CardNumber}
            rules={{
              required: Boolean(
                cardNumberCondition[
                  (
                    watch(InsuranceFormData.TPA.name) ||
                    watch(InsuranceFormData.Insurance.name)
                  )?.id as keyof typeof cardNumberCondition
                ]
              )
                ? false
                : InsuranceFormData.CardNumber.rules.required,
            }}
          />
          <CustomFormField
            control={control}
            {...InsuranceFormData.PolicyNumber}
          />

          <CustomFormField
            control={control}
            {...InsuranceFormData.PolicyFrom}
            rules={{
              ...InsuranceFormData.PolicyFrom.rules,
              onChange: policyFomChange,
            }}
          />

          <CustomFormField
            control={control}
            {...InsuranceFormData.PolicyTill}
          />

          <CustomFormField control={control} {...InsuranceFormData.AsopNo} />
        </div>
      </Paper>
      <CustomModal
        title="Copay/Deductible"
        open={open}
        setOpen={setOpen}
        handleClose={collectCopayDeductible}
      >
        <Box sx={style}>
          {/* <div className="p-5 border-b flex flex-row justify-between">
            <Typography
              component="h6"
              variant="h6"
              sx={{ fontSize: "1rem", fontWeight: "bold" }}
            >
              Copay/Deductible
            </Typography>
          </div> */}
          <div className="flex flex-col gap-3 p-5">
            {cptGroups?.response?.map((item: any, index: number) => (
              <div className="grid grid-cols-3 gap-3" key={index + item.id}>
                <span>{item.name}</span>
                <TextField
                  {...register(item.name + "copay")}
                  defaultValue={copay[index]?.copay || 0}
                  id={"copay" + item.id}
                  size="small"
                  label="Copay"
                  type="number"
                  inputProps={{
                    min: 0,
                  }}
                />
                <TextField
                  {...register(item.name + "deductible")}
                  defaultValue={copay[index]?.deductible || 0}
                  id={"deductible" + item.id}
                  size="small"
                  label="Deductible"
                  type="number"
                  inputProps={{
                    min: 0,
                  }}
                />
              </div>
            ))}
            <div className="flex flex-row justify-end gap-2">
              <Button
                color="error"
                onClick={() => {
                  setOpen(false);
                }}
              >
                cancel
              </Button>
              <Button color="primary" onClick={collectCopayDeductible}>
                ok
              </Button>
            </div>
          </div>
        </Box>
      </CustomModal>
    </div>
  );
}

export default Insuranceform;

const cardNumberCondition = {
  112: true,
};
